<template>
  <div :class="popupView ? 'company-transport-filter':'company-transport-inline'">
    <div class="inner-company-transport-filter">
      <tsoft-wrapper :loading="loading">
        <form class="mb-1 pb-0">
          <h6 
            class="mt-0 mb-0 cursor-pointer" 
            @click="collapses.companyMain=!collapses.companyMain"
          >Отфильтровать компании по параметрам
            <span v-if="!collapses.companyMain"><b-icon icon="arrow-down-square" aria-hidden="true"></b-icon></span>
            <span v-if="collapses.companyMain"><b-icon icon="arrow-up-square" aria-hidden="true"></b-icon></span>
          </h6>
          <span v-if="!collapses.companyMain" style="font-size: 11px;">Нажмите, чтобы раскрыть список свойств.</span>
          <b-collapse id="collapse-companyMain" v-model="collapses.companyMain" class="mt-2">
            <div class="form-row">
              <div class="form-group mb-1 col-md-12 corrected-multiselect__tags small-tags">
                <label class="small" for="type_of_transport_company">Тип поставщика</label>
                <multiselect
                  :key="`type_of_transport_company_${allKeysUpdater}`"
                  v-model="typeOfTransportCompany"
                  tag-placeholder=""
                  placeholder="Начните вводить значение..."
                  select-label=""
                  label="text"
                  track-by="value"
                  :options="typeOfTransportCompanyList"
                  :multiple="true"
                  :taggable="true"
                  :hide-selected="true"
                >
                  <span slot="noResult">Ничего не найдено. Попробуйте снова...</span>
                </multiselect>       
              </div>
              <div class="form-group mb-1 col-md-8 corrected-multiselect__tags small-tags">
                <label class="small">Сегменты услуг компании</label>
                <tsoft-select-of-properties
                  :key="`set_services_ids_${allKeysUpdater}`"
                  :reference_id="86"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_services_ids"
                  @set="setServicesOfCompany"
                ></tsoft-select-of-properties>
              </div>
              <div class="form-group mb-1 col-md-4" v-if="availableTypes.size > 0">
                <label class="small">Сотрудники по сегментам</label>
                <b-form-checkbox
                  v-model="searchData.need_employees_with_segments"
                  name="need_employees_with_segments"
                  id="need_employees_with_segments"
                  class="mt-1"
                  title="Если выключить, будут допущены компании без контактов, отвечающих за сегменты."
                  switch
                >
                  Обязательно
                </b-form-checkbox>
              </div>
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small">Специальные возможности</label>
                <tsoft-select-of-properties
                  :key="`set_special_features_ids_${allKeysUpdater}`"
                  :reference_id="82"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_special_features_ids"
                  @set="setSpecialFeaturesOfCompany"
                ></tsoft-select-of-properties>
              </div>
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small">Страхование ответственности</label>
                <tsoft-select-of-properties
                  :key="`set_insurance_data_${allKeysUpdater}`"
                  :reference_id="83"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_insurance_data"
                  @set="setInsuranceOfCompany"
                ></tsoft-select-of-properties>
              </div>
            </div>
          </b-collapse>
          
          <h6 
            class="mt-3 mb-0 cursor-pointer" 
            @click="collapses.companyGeography=!collapses.companyGeography"
          >Фильтр по географии деятельности 
            <span v-if="!collapses.companyGeography"><b-icon icon="arrow-down-square" aria-hidden="true"></b-icon></span>
            <span v-if="collapses.companyGeography"><b-icon icon="arrow-up-square" aria-hidden="true"></b-icon></span>
          </h6>
          <span v-if="!collapses.companyGeography" style="font-size: 11px;">Нажмите, чтобы раскрыть список свойств.</span>
          <b-collapse id="collapse-companyGeography" v-model="collapses.companyGeography" class="mt-2">
            <div class="form-row">
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small">Страны регистрации филиалов и обособленных подразделений</label>
                <tsoft-select-of-properties
                  :key="`set_countries_of_branches_ids_${allKeysUpdater}`"
                  :reference_id="20"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_countries_of_branches_ids"
                  @set="setCountriesOfBranchesOfCompany"
                ></tsoft-select-of-properties>
              </div>              
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small">Страны регистрации собственного подвижного состава</label>
                <tsoft-select-of-properties
                  :key="`set_countries_of_rolling_stock_ids_${allKeysUpdater}`"
                  :reference_id="20"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_countries_of_rolling_stock_ids"
                  @set="setCountriesOfRollingStocksOfCompany"
                ></tsoft-select-of-properties>
              </div>              
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small" for="set_uploading_geography_ids">Страны загрузки</label>
                <tsoft-select-of-properties
                  :key="`set_uploading_geography_ids_${allKeysUpdater}`"
                  :reference_id="20"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_uploading_geography_ids"
                  @set="setUploadingGeography"
                ></tsoft-select-of-properties>
              </div>
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small" for="set_unloading_geography_ids">Страны разгрузки</label>
                <tsoft-select-of-properties
                  :key="`set_unloading_geography_ids_${allKeysUpdater}`"
                  :reference_id="20"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_unloading_geography_ids"
                  @set="setUnloadingGeography"
                ></tsoft-select-of-properties>
              </div>
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small" for="set_transit_directions_ids">Транзит</label>
                <tsoft-select-of-properties
                  :key="`set_transit_directions_ids_${allKeysUpdater}`"
                  :reference_id="85"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_transit_directions_ids"
                  @set="setTransitDirections"
                ></tsoft-select-of-properties>
              </div>
              <div class="form-group mb-1 col-md-6 corrected-multiselect__tags small-tags">
                <label class="small" for="set_rf_directions_ids">Направления (относительно РФ)</label>
                <tsoft-select-of-properties
                  :key="`set_rf_directions_ids_${allKeysUpdater}`"
                  :reference_id="84"
                  :needNullElement="false"
                  :needMultipleSelect="true"
                  :defaultSelectName="``"
                  :selectedArray="searchData.set_rf_directions_ids"
                  @set="setRfDirections"
                ></tsoft-select-of-properties>
              </div>
            </div>            
          </b-collapse>          
  
          <template v-if="availableTypes.size > 0">
            <h6 
              class="mt-3 mb-0 cursor-pointer" 
              @click="collapses.podvignoySostav=!collapses.podvignoySostav"
            >Фильтр по подвижному составу 
              <span v-if="!collapses.podvignoySostav"><b-icon icon="arrow-down-square" aria-hidden="true"></b-icon></span>
              <span v-if="collapses.podvignoySostav"><b-icon icon="arrow-up-square" aria-hidden="true"></b-icon></span>
            </h6>
            <span v-if="!collapses.podvignoySostav" style="font-size: 11px;">Нажмите, чтобы раскрыть список свойств.</span>
            <div class="form-row">
              <b-collapse id="collapse-podvignoySostav" v-model="collapses.podvignoySostav" class="mt-2">
                <b-row>
                  <b-col cols="6">
                    <label class="small ml-3 pl-1">Выберите тип:</label>
                    <b-list-group class="small-lists">
                      <b-list-group-item 
                        class="d-flex justify-content-between align-items-center"
                        v-for="(category, index) in transportCategories"
                        :key="`category_id_${category.id}`"
                        v-if="availableTypes.has(category.type)"
                        :active="category.opened"
                        style="width: 250px;"
                      >
                        <span class="cursor-pointer mr-2" @click="setTransportCategory(index)">
                          <b-icon v-if="!category.selected" icon="check-square" aria-hidden="true"></b-icon>
                          <b-icon v-if="category.selected" icon="check-square-fill"  variant="success" aria-hidden="true"></b-icon>
                        </span>
                      
                        <span class="cursor-pointer text-right w100" @click="openTransportCategory(index)">
                          {{ category.name }}
                        </span>
                        <b-badge :variant="category.choosed > 0 ? 'primary':'secondary'" class="ml-2" pill>{{ calcChoosed(category, index) }}</b-badge>
                      </b-list-group-item>
                    </b-list-group>                  
                  </b-col>
                  <b-col cols="6" v-if="activeCategoryIndex != -1">
                    <label class="small ml-3 pl-1">Выберите вид:</label>
                    <b-list-group class="small-lists">
                      <b-list-group-item 
                        @click="setTransportItem(i_idx)"
                        class="d-flex justify-content-between align-items-center"
                        v-for="(item, i_idx) in transportCategories[activeCategoryIndex].transport_items"
                        :key="`item_id_${item.id}`"
                        style="width: 250px;"
                      >
                        <span class="cursor-pointer mr-2">
                          <b-icon v-if="!item.selected" icon="check-square" aria-hidden="true"></b-icon>
                          <b-icon v-if="item.selected" icon="check-square-fill"  variant="success" aria-hidden="true"></b-icon>
                        </span>
                      
                        <span class="cursor-pointer text-left w100">
                          {{ item.name }}
                        </span>
                      </b-list-group-item>
                    </b-list-group>                  
                  </b-col>
                </b-row>
              </b-collapse>          
            </div>
          </template>
        </form>
      </tsoft-wrapper>
    </div>
    <div class="text-right fly-filter-buttons" :style="popupView ? '':'position: relative;'">
      <button
        class="btn btn-outline-primary ml-3"
        @click.prevent="searchCompanies()"
      >Поиск компаний<i class="fas fa-spinner fa-spin ml-1" v-if="searchingProcess"></i></button>

      <b-form-checkbox
        v-model="searchData.merged_big_search"
        name="merged_big_search"
        id="merged_big_search"
        class="ml-3"
        title="Если включить, попадать будут компании при соответствии хотя бы одного из выбранных параметров."
        switch
      >
        Не строгий поиск
      </b-form-checkbox>

      <b-button 
        v-if="popupView"
        class="ml-3"
        @click="disableSearch"
        :disabled="searchingProcess"
      >Закрыть</b-button>

      <b-button 
        class="ml-3"
        @click="clearSearchData"
        :disabled="searchingProcess"
      >Сбросить</b-button>
    </div>
  </div>
</template>

<script>
  import { API_TRANSPORT_TYPES_BY_CATEGORY } from '@/constants';

  import {
      typeOfTransportCompanyList,
  } from '@/mixins';

  const initialItem = () => ({
    merged_big_search: false,
    type_of_transport_company: ['Агент', 'Собственник', 'Перевозчик', 'Экспедитор'],
    set_services_ids: [],
    need_employees_with_segments: false,
    set_special_features_ids: [],
    set_countries_of_branches_ids: [],
    set_countries_of_rolling_stock_ids: [],
    set_uploading_geography_ids: [],
    set_unloading_geography_ids: [],
    set_transit_directions_ids: [],
    set_rf_directions_ids: [],
    set_transport_categories: [],
    set_insurance_data: []
  });

  const initialTypeOfTransport = () => ([
    { text: 'Агент', value: 'Агент' },
    { text: 'Собственник', value: 'Собственник' },
    { text: 'Перевозчик', value: 'Перевозчик' },
    { text: 'Экспедитор', value: 'Экспедитор' },
  ]);

  export default {
      props: {
        popupView: { type: Boolean, default: true },
        searchParameters: { type: Object, required: false },
      },
      mixins: [
          typeOfTransportCompanyList,
      ],        
      components: {
      },
      data() {
        return {
          loading: true,
          activeIndex: 0,
          searchingProcess: false,
          typeOfTransportCompany: [],
          searchData: {},
          allKeysUpdater: 1,
          collapses: {
            companyMain: true,
            companyGeography: false,
            podvignoySostav: true
          },
          availableTypes: new Set(),
          transportCategoriesDefault: [],
          transportCategories: [],
          activeCategoryIndex: -1
        }
      },
      watch: {
        typeOfTransportCompany: {
          deep: true,
          immediate: true,
          handler(tags) {
            this.searchData.type_of_transport_company = [];

            if (tags && tags.length > 0) {
              tags.forEach((tag) => {
                this.searchData.type_of_transport_company.push(tag.value);
              });
            }
          },
        }, 
        transportCategories: {
          deep: true,
          handler(cats) {
            this.activeCategoryIndex = -1;

            cats.forEach((cat, index) => {
              if (cat.opened) {
                this.activeCategoryIndex = index;
              }
            });
          },
        },
        searchParameters: {
          deep: true,
          immediate: true,
          handler(params) {
            this.restoreSettingsOfSearch();
          },
        },
        availableTypes: {
          deep: true,
          handler(newT, prevT) {
            this.recalculateTransportItems();

            if (newT.size > 0 && prevT.size == 0) {
              this.searchData.need_employees_with_segments = true;
            } else if (newT.size == 0) {
              this.searchData.need_employees_with_segments = false;
            }
          },
        }
      },        
      mounted() {
        this.typeOfTransportCompany = initialTypeOfTransport();
        this.searchData = initialItem();
        this.restoreSettingsOfSearch();
        this.loadTransportTypes();
      },
      methods: {
        loadTransportTypes() {
          api.call('get', `${API_TRANSPORT_TYPES_BY_CATEGORY}`).then(({data}) => {
            data.forEach((category, c_idx) => {
              data[c_idx].selected = false;
              data[c_idx].opened = false;
              data[c_idx].choosed = 0;

              if (category.transport_items) {
                category.transport_items.forEach((item, i_idx) => {
                  data[c_idx].transport_items[i_idx].selected = false;
                });
              }
            });

            this.transportCategories = data;
            this.transportCategoriesDefault = JSON.parse(JSON.stringify(data));
            this.loading = false;

            this.restoreSettingsOfSearch();
          })
        },        
        disableSearch() {
          this.$emit('disableSearch', true);
        },
        searchCompanies() {
          this.prepareTransportSearchData();
          this.$emit('startSearch', this.searchData);
        },
        prepareTransportSearchData() {
          this.searchData.set_transport_categories = [];

          this.transportCategories.forEach((category) => {
            category.transport_items.forEach((item) => {
              if (item.selected) {
                this.searchData.set_transport_categories.push(item.id);
              }
            });
          })
        },
        restoreSettingsOfSearch() {
          if (this.searchParameters && this.searchParameters.set_services_ids) {
            this.searchData = JSON.parse(JSON.stringify(this.searchParameters));
            this.restoreTransportTypesSelectivity();
          }
        },
        restoreTransportTypesSelectivity() {
          this.transportCategories.forEach((category, cat_idx) => {
            category.transport_items.forEach((item, item_idx) => {
              if (this.searchData.set_transport_categories.includes(item.id)) {
                this.transportCategories[cat_idx]['transport_items'][item_idx]['selected'] = true;
              } else {
                this.transportCategories[cat_idx]['transport_items'][item_idx]['selected'] = false;
              }
            });
          })
        },
        clearSearchData() {
          this.searchData = {};
          this.typeOfTransportCompany = initialTypeOfTransport();
          this.transportCategories = JSON.parse(JSON.stringify(this.transportCategoriesDefault));
          this.availableTypes = new Set();
          this.searchCompanies();
          this.allKeysUpdater++;
        },
        setServicesOfCompany(value) {
            this.searchData.set_services_ids = value;
            this.availableTypes = new Set();

            this.searchData.set_services_ids.forEach((service_id) => {
              if ([994, 995, 996, 997].includes(service_id)) {
                this.availableTypes.add('FCL и LCL');
              } else if ([992, 993].includes(service_id)) {
                this.availableTypes.add('FTL и LTL');
              }
            });
        },
        setSpecialFeaturesOfCompany(value) {
            this.searchData.set_special_features_ids = value;
        },
        setCountriesOfBranchesOfCompany(value) {
            this.searchData.set_countries_of_branches_ids = value;
        },
        setCountriesOfRollingStocksOfCompany(value) {
            this.searchData.set_countries_of_rolling_stock_ids = value;
        },
        setUploadingGeography(value) {
          this.searchData.set_uploading_geography_ids = value;
        },
        setUnloadingGeography(value) {
          this.searchData.set_unloading_geography_ids = value;
        },
        setTransitDirections(value) {
          this.searchData.set_transit_directions_ids = value;
        },
        setRfDirections(value) {
          this.searchData.set_rf_directions_ids = value;
        },
        setInsuranceOfCompany(value) {
          this.searchData.set_insurance_data = value;
        },
        setTransportCategory(index) {
          this.transportCategories[index].selected = !this.transportCategories[index].selected;

          this.transportCategories[index].transport_items = this.transportCategories[index].transport_items.map((item) => {
            item.selected = this.transportCategories[index].selected;

            return item;
          })
        },
        setTransportItem(index) {
          this.transportCategories[this.activeCategoryIndex].transport_items[index].selected = !this.transportCategories[this.activeCategoryIndex].transport_items[index].selected;
        },
        openTransportCategory(index) {
          this.transportCategories[index].opened = !this.transportCategories[index].opened

          this.transportCategories = this.transportCategories.map((item, idx) => {
            if (index != idx) {
              item.opened = false;
            }

            return item;
          });
        },
        calcChoosed(category, index) {
          let result = 0;

          category.transport_items.forEach((item)=> {
            if (item.selected) {
              result++;
            }
          })

          this.transportCategories[index].choosed = result;

          return result;
        },
        recalculateTransportItems() {
          this.transportCategories.forEach((category, cat_idx) => {
            if (!this.availableTypes.has(category.type)) {
              category.transport_items.forEach((item, item_idx) => {
                this.transportCategories[cat_idx]['transport_items'][item_idx].selected = false;
              });
            }
          });
        }
      }
  }
</script>

<style scoped>
  .company-transport-inline {
    border: 1px solid #ededed;
  }
  .company-transport-filter { 
    position: absolute;
    background: #FFF;
    left: 40px;
    top: -9px;
    width: 100%;
    min-width: 700px;
    height: 576px;
    z-index: 20;
    border: 1px solid #ededed;
    -webkit-box-shadow: -0px 0px 100px 0 rgb(116 116 116);
    -moz-box-shadow: -0px 0px 100px 0 rgb(116 116 116);
    box-shadow: -0px 0px 100px 0 rgb(116 116 116);   
  }
  .inner-company-transport-filter {
    position: relative;
    width: 100%;
    max-height: 500px;
    padding: 13px 20px;
    overflow-y: auto; 
    scrollbar-width: thin;
  }
    .company-transport-inline .inner-company-transport-filter {
      padding: 0px;
    }
    .company-transport-inline .inner-company-transport-filter .wrapper {
      border-radius: 0;
      box-shadow: none;
    }
  .fly-filter-buttons {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #f3f3f3;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    height: 50px;
    padding-right: 30px;
    -webkit-box-shadow: 0px 5px 5px -5px rgba(34, 60, 80, 0.6) inset;
    -moz-box-shadow: 0px 5px 5px -5px rgba(34, 60, 80, 0.6) inset;
    box-shadow: 0px 5px 5px -5px rgba(34, 60, 80, 0.6) inset;    
  }
</style>